import styled, { css } from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _LandingHighlighProductPetitPrinceRoot = styled("section")<{}>(
  () => {
    return css`
      position: relative;
      padding-top: 180px;

      @media ${responsiveMap.mobile} {
        padding: 24px;
        padding-top: 0;
        padding-bottom: 62px;
      }

      .landing-action-button {
        @media ${responsiveMap.maxLg} {
          width: 100%;
        }
      }

      .top-container {
        @media ${responsiveMap.maxLg} {
          margin-bottom: 38px;
        }
      }

      .landing-section-base.landing-section-base__head
        .landing-section-base__head__container {
        @media ${responsiveMap.mobile} {
          padding: 0px;
          flex-direction: column-reverse;
        }
      }

      .landing-section-base__head__content {
        position: relative;
        padding-bottom: 90px;
        max-width: unset;

        @media ${responsiveMap.mobile} {
          padding-bottom: 0;
        }
      }
      .landing-section-base__head__bottom {
        max-width: unset;
        &.fill-top-content {
          align-items: flex-end;
        }
      }

      .composition-container {
        margin-top: 0px;
      }

      .landing-section-base__head__top__container {
        @media ${responsiveMap.mobile} {
          flex-direction: column-reverse;
        }
      }

      .landing-section-base__head__middle {
        align-items: baseline;
        /* max-width: 711px; */
        /* max-width: 67%; */
        position: relative;
        transform: translateX(48px);

        @media ${responsiveMap.mobile} {
          max-width: 466px;
          margin: 0 auto;
          transform: translateX(0);
        }
      }

      .composition-items {
        .composition-item-separator {
          margin-bottom: 10px;
        }
      }

      .landing-action-button {
        @media ${responsiveMap.mobile} {
          width: unset;
        }
      }
    `;
  }
);
